<template>
  <div>
    <v-card class="mt-6" outlined>
      <v-data-table :headers="headers" :items="items" :items-per-page="itemsPerPage" :page.sync="page"
        :loading="tableLoader" @page-count="$emit('update:pageCount', $event)" hide-default-footer
        loading-text="Loading... Please wait">
        <template v-slot:[`item.index`]="{ index }">
          <b>{{ index + itemsPerPage * (page - 1) + 1 }}</b>
        </template>
        <template v-slot:[`item.LocationAddress`]="{ item }">
          <span class="table_style_two">
            {{ item.EventLocationType == 1 ? item.LocationAddress : item.UrlLink }}
          </span>
        </template>
        <template v-slot:[`item.EventDate`]="{ item }">
          <span class="table_style_two">
            {{ item.OccurrenceType == "One-Time Event" ? formatDate(item.EventDate) : "" }}
          </span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu transition="scroll-y-transition" offset-y color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="A1A1A6" v-bind="attrs" v-on="on">mdi-dots-horizontal</v-icon>
            </template>
            <v-card flat>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block class="d-flex justify-start"
                  @click="$emit('previewEvent', item)">
                  <v-icon color="#646464">mdi-open-in-new</v-icon>
                  <span class="ml-4 text_style">Preview</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block class="d-flex justify-start"
                  @click="$emit('editEvent', item)">
                  <v-icon color="#646464">mdi-pencil</v-icon>
                  <span class="ml-4 text_style">Edit</span>
                </v-btn>
              </v-list>
              <v-list class="px-3 pt-1" color="transparent">
                <v-btn depressed color="transparent" block class="d-flex justify-start"
                  @click="$emit('deleteEvent', item)">
                  <v-icon color="#646464">mdi-delete</v-icon>
                  <span class="ml-4 text_style">Delete</span>
                </v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </template>
      </v-data-table>
    </v-card>
    <v-card flat class="my-9 d-flex justify-end align-center">
      <span class="text_transform pa-0 ma-0">Per page : </span>
      <v-card flat width="100" class="mx-5">
        <v-select :items="ItemsPerPageItems" label="Items per page" v-model="itemsPerPage"
          @input="$emit('update:itemsPerPage', $event)" />
      </v-card>
      <v-pagination v-model="page" :length="pageCount" :total-visible="5" @input="$emit('update:page', $event)" />
    </v-card>
  </div>
</template>

<script>
export default {
  name: "EventTable",
  props: {
    headers: Array,
    items: Array,
    page: Number,
    pageCount: Number,
    itemsPerPage: [Number, String],
    ItemsPerPageItems: Array,
    tableLoader: Boolean,
  },
  methods: {
    formatDate(dateString) {
      if (dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString();
      }
      return "";
    },
  },
};
</script>

<style scoped>
.table_style_two {
  font-family: "DM Sans";
  font-size: 14px;
}

.text_style {
  font-family: "DM Sans";
  font-size: 14px;
  text-transform: capitalize;
}
</style>